import React, { useState } from "react";
import GeneradorModal from "./GeneradorModal";
import Modal from "react-modal";

Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    paddingLeft: 0,
    padding: 0,
    fontFamily: "Roboto, sans-serif",
    "::WebkitScrollbar": {
      width: "0px",
      background: "transparent",
    },
    msOverflowStyle: "none",
    scrollbarWidth: "none",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 102,
  },
};

const EditarReporte = ({
  reporte,
  clientes,
  productos,
  setReportes,
  reportes,
  onClose,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(true);

  const closeModal = () => {
    setModalIsOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Editar Reporte"
      >
        <button onClick={closeModal} className="cerrar-button">
          <i className="bi bi-x-lg"></i>
        </button>
        <div className="editar-cotizacion-form">
          {/* Usamos la prop editingReport para precargar los datos en GeneradorModal */}
          <GeneradorModal
            editingReport={reporte}
            numeroReporte={reporte?.numeroReporte}
            clientes={clientes}
            productos={productos}
            setReportes={setReportes}
            reportes={reportes}
            closeModal={closeModal}
          />
        </div>
      </Modal>
    </>
  );
};

export default EditarReporte;
